import React from 'react';
import PropTypes from 'prop-types';
import { Bolt } from '@mui/icons-material';
import { Link } from 'react-router-dom';

const NoDataOverlay = ({ title, body, ctaLabel, ctaPath }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" />
      <div className="relative w-full max-w-xl rounded-2xl border border-slate-200 bg-white p-6 shadow-2xl shadow-blue-500/20 dark:border-slate-700 dark:bg-slate-900">
        <div className="flex items-start gap-3">
          <div className="rounded-xl bg-blue-50 p-2 text-blue-700 dark:bg-blue-900/40 dark:text-blue-200">
            <Bolt className="h-5 w-5" />
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-wide text-slate-500 dark:text-slate-400">
              Feature Info
            </p>
            <h3 className="text-lg font-bold text-slate-900 dark:text-slate-100">
              {title}
            </h3>
          </div>
        </div>

        <p className="mt-4 text-sm leading-relaxed text-slate-600 dark:text-slate-300">
          {body}
        </p>

        {ctaLabel && ctaPath && (
          <p className="mt-3 text-sm leading-relaxed text-slate-600 dark:text-slate-300">
            <Link
              to={ctaPath}
              className="font-semibold text-blue-600 underline hover:text-blue-700 dark:text-blue-300 dark:hover:text-blue-200"
            >
              {ctaLabel}
            </Link>
          </p>
        )}
      </div>
    </div>
  );
};

NoDataOverlay.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  ctaLabel: PropTypes.string,
  ctaPath: PropTypes.string
};

export default NoDataOverlay;
